import  useMessage from './useMessage';
export default useMessage
